export default "__VITE_ASSET__02ea491b__"